<template>
  <v-card class="mx-4 my-6" :style="cardClass" id="group-network-health">
    <v-card-title class="pr-0" style="word-break: normal">
      <v-card-text
        class="
        text-h6
        font-weight-medium
        text-uppercase
        pa-0
      "
      >
        Network Health
      </v-card-text>
    </v-card-title>
    <div v-if="loadingStates.networkHealth">
      <chart :loading="loadingStates.networkHealth"></chart>
    </div>
    <div
      class="d-flex align-center justify-center"
      v-else-if="totalDevices > 0 && !loadingStates.networkHealth"
    >
      <chart
        type="donut"
        id="network-health-chart"
        :data="statusChart ? statusChart.data : []"
        :labels="statusChart ? statusChart.labels : []"
        subtitle="Network Health"
        class="pa-0"
        elevation="0"
        :width="chartWidth"
        :loading="loadingStates.networkHealth"
      >
      </chart>
      <v-card-text
        style="position: absolute; top: 35%; z-index:2;"
        class="text-center text-subtitle-2 font-weight-medium black--text"
      >
        <span id="group-total-devices">
          {{ totalDevices }}
        </span>
        <br />
        <span>
          Total Devices
        </span>
      </v-card-text>
    </div>
    <div v-else>
      <v-card-text
        style="z-index:500;"
        class="text-center text-subtitle-2 font-weight-medium black--text mb-10 mt-10"
      >
        <span id="group-total-devices">
          There are no devices associated with this group
        </span>
        <br />
      </v-card-text>
    </div>
    <v-row>
      <v-col class="mx-4">
        <v-text-field
          filled
          dense
          id="warning-trigger"
          v-model="computedWarningTrigger"
          label="Days to trigger yellow designation:"
          type="number"
        />
        <v-text-field
          filled
          dense
          id="danger-trigger"
          type="number"
          v-model="computedDangerTrigger"
          label="Days to trigger red designation:"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import Chart from '@/components/charts/Chart';
import GroupDetailData from '@/mixins/GroupDetailData';
import { MobileView } from '@/mixins';

export default {
  mixins: [GroupDetailData, MobileView],
  data() {
    return {
      warningTriggerOptions: ['1 Day', '2 Days', '3 Days', '4 Days'],
      triggerDangerOptions: ['Low', 'Medium', 'High'],
    };
  },
  components: {
    Chart,
  },
  computed: {
    ...mapGetters({
      statusChart: 'groupDetails/getStatusChart',
      loadingStates: 'groupDetails/getGraphLoadingStates',
    }),
    totalDevices() {
      let total = 0;
      if (this.statusChart && this.statusChart.data) {
        for (let i = 0; i < this.statusChart.data.length; i++) {
          total += this.statusChart.data[i];
        }
      }
      total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return total;
    },
    cardClass() {
      if (this.showMobileView) {
        return '';
      }
      return 'width:30%; overflow:hidden;';
    },
    chartWidth() {
      if (this.showMobileView) {
        return '';
      }
      return '400px';
    },
    computedWarningTrigger: {
      get() {
        return this.details.tablet_settings
          ? Number(this.details.tablet_settings.warning_trigger)
          : '';
      },
      set(val) {
        this.details.tablet_settings.warning_trigger = val;
      },
    },
    computedDangerTrigger: {
      get() {
        return this.details.tablet_settings
          ? Number(this.details.tablet_settings.danger_trigger)
          : '';
      },
      set(val) {
        this.details.tablet_settings.danger_trigger = val;
      },
    },
  },
};
</script>
